import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  new_messages: {
    data: 0
  },
  loadedChatMessages: {},
  messageThreadPreviews: {}
}

const messageSlice = createSlice({
  name: 'messages',
  initialState,
  reducers: {
    setMessages(state, { payload }) {
      Object.entries(payload).forEach(([id, messageData]) => {
        state.messageThreadPreviews[id] = { ...state.messageThreadPreviews[id], ...messageData }
      })
    },
    setFirstMessages(state, { payload }) {
      state.first_messages = { ...payload }
    },
    setLoadFetchedMessages(state, { payload }) {
      for (const [key, value] of Object.entries(payload)) {
        state.loadedChatMessages[key] = value
      }
    },
  },
})

export const { setMessages, setFirstMessages, setLoadFetchedMessages } = messageSlice.actions
export default messageSlice.reducer
